import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
  SaveButton,
  ClearButton,
  GenerateMenuButton,
  GeneratePDFButton,
  SaveToTemplateButton,
  PublishComplexButton,
} from '../../Common/ActionsButtons';

const GenerateButton = ({
  handleMenuGenerateClick,
  user,
  loader,
  saveMenus,
  isDisabledSaveBtn,
  handleGetPDFClick,
  isDisabledGetPDFBtn,
  menuToTemplate,
  isDisabledTemplateBtn,
  handleMenuClearClick,
  selectedComplex,
  toggleIsShowConfirmPublishComplex,
}) => {
  return (
    <ControlButtonBlock>
      <SaveButton onClick={saveMenus} disabled={isDisabledSaveBtn || loader}>
        Сохранить меню клиенту
      </SaveButton>
      <GeneratePDFButton onClick={handleGetPDFClick} disabled={isDisabledGetPDFBtn || loader}>
        Сгенерировать PDF
      </GeneratePDFButton>
      <GenerateMenuButton onClick={handleMenuGenerateClick} disabled={!user.id || loader}>
        Сгенерировать меню
      </GenerateMenuButton>
      <ClearButton onClick={handleMenuClearClick} disabled={loader}>
        Очистить меню
      </ClearButton>
      {!loader && (
        <NavLink className="prevent-link-styles" to="/templateGenerator">
          <SaveToTemplateButton onClick={menuToTemplate}>
            {isDisabledTemplateBtn ? 'Создать шаблон' : 'Сохранить в шаблон'}
          </SaveToTemplateButton>
        </NavLink>
      )}
      {!loader &&
        !!selectedComplex &&
        !!selectedComplex.foodCourse &&
        !!selectedComplex.name &&
        !!selectedComplex.name.includes('Draft') && (
          <PublishComplexButton onClick={() => toggleIsShowConfirmPublishComplex()}>
            Опубликовать комплекс курс
          </PublishComplexButton>
        )}
      <EmptyButtonBlock />
    </ControlButtonBlock>
  );
};
export default GenerateButton;

const ControlButtonBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 40px;
`;

const EmptyButtonBlock = styled.div`
  display: block;
  width: 300px;
  margin: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/DetailsForGenerateBlock/GenerateButton.jsx